export default "__VITE_ASSET__d975629b__"